import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ExternalServiceLink from '../views/ExternalServiceLink.vue'
import ExternalServiceOAuth from '../views/ExternalServiceOAuth.vue'
import ExternalServiceOAuthStart from '../views/ExternalServiceOAuthStart.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import NestLanding from '../views/NestLanding.vue'
import SelfProvidedOAuthScreen from '../views/SelfProvidedOAuthScreen.vue'
import YandexBlocker from '../views/YandexBlocker.vue'

Vue.use(VueRouter)

const routes = [
  {
    meta: {
      title: 'iRidi services',
    },
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    meta: {
      title: 'iRidi services',
    },
    path: '/services/policy/nest/privacy-policy-for-access-to-google-apis/:lang',
    name: 'Privacy policy for access to google API`s',
    component: PrivacyPolicy,
  },
  {
    meta: {
      title: 'iRidi services',
    },
    path: '/services/nest/:lang',
    name: 'Integration iRidi Assistant with Nest',
    component: NestLanding,
  },
  {
    meta: {
      title: 'External service link',
    },
    path: '/services/:externalService/link',
    name: 'External service link',
    component: ExternalServiceLink,
  },
  {
    meta: {
      title: 'External OAuth link with iRidi',
    },
    path: '/services/oauth/:product/:externalService',
    name: 'External OAuth link with iRidi',
    component: ExternalServiceOAuth,
  },
  {
    meta: {
      title: 'External services connect',
    },
    path: '/services/oauth/available',
    name: 'External services connect',
    component: ExternalServiceOAuthStart,
  },
  {
    meta: {
      title: 'OAuthScreen',
    },
    path: '/services/oauth2screen/authorize',
    name: 'External services connect',
    component: SelfProvidedOAuthScreen,
  },
  {
    meta: {
      title: 'Yandex blocker',
    },
    path: '/yandex/blocker',
    name: 'Yandex blocker',
    component: YandexBlocker,
  },
  {
    meta: {
      title: 'About',
    },
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: `${process.env.BASE_URL}`,
  routes,
})

export default router
